import { NgOptimizedImage } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, input, output, signal } from '@angular/core';
import { UrlConstants } from '../../pages/common/constants/url.constants';
import { openInNewTab } from '../../pages/common/utils/navigate-to';
import { GlossaryModalComponent } from '../glossary-modal/glossary-modal.component';
import { FsthpMasterDataStore } from '../services/fsthp-master-data.store';

@Component({
  selector: 'app-page-header',
  imports: [GlossaryModalComponent, NgOptimizedImage],
  templateUrl: './page-header.component.html',
  styleUrls: ['./page-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PageHeaderComponent {
  /** マスタデータストア（アプリ起動時に一度だけロードする） */
  protected readonly masterDataStore = inject(FsthpMasterDataStore);
  private readonly defaultOfficialSiteUrl = 'https://www.dai-ichi-life.co.jp/';
  /** URLコンスタント */
  protected readonly UrlConstants = UrlConstants;

  /** ハンバーガーメニューの開閉状態 */
  readonly isMenuOpen = input(false);

  /** ヘッダー右側の操作群（用語解説・FAQ・閉じる・メニュー）を表示するか */
  readonly showActions = input(true);

  /** メニューを開く */
  readonly menuOpen = output<void>();

  /** メニューを閉じる */
  readonly menuClose = output<void>();

  protected glossaryOpen = signal(false);

  /**
   * ロゴクリック時にオフィシャルHPを別タブで表示
   */
  openOfficialSite(): void {
    openInNewTab(this.masterDataStore.getTransitionDestinationUrl(UrlConstants.COMPANY_ICON_URL) ?? this.defaultOfficialSiteUrl);
  }

  /**
   * よくある質問を別タブで表示する（マスタURLが無い場合は何もしない）
   */
  openFaq(): void {
    const faqUrl = this.masterDataStore.getTransitionDestinationUrl(UrlConstants.FAQ_URL);
    if (faqUrl) {
      openInNewTab(faqUrl);
    }
  }

  openGlossary(event: Event): void {
    event.preventDefault();
    this.glossaryOpen.set(true);
  }

  closeGlossary(): void {
    this.glossaryOpen.set(false);
  }

  /**
   * ウィンドウを閉じる（PCヘッダー）
   */
  closeWindow(): void {
    window.close();
  }

  onMenuButtonClick(): void {
    if (this.isMenuOpen()) {
      this.menuClose.emit();
      return;
    }
    this.menuOpen.emit();
  }
}
